/** EQ bandi - frekvencija (Hz) i naziv za UI */
export const EQ_BANDS = [
  { freq: 60, label: '60 Hz' },
  { freq: 230, label: '230 Hz' },
  { freq: 910, label: '910 Hz' },
  { freq: 3600, label: '3.6 kHz' },
  { freq: 14000, label: '14 kHz' },
] as const;

export const EQ_MIN_GAIN = -12;
export const EQ_MAX_GAIN = 12;
export const EQ_DEFAULT_GAIN = 0;
